var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WIP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients",
    transform: "translate(-1354.000000, -109.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(1268.000000, 97.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.4715262,18.7808219 C94.0523918,18.0502283 94.3712984,17.1255708 94.3712984,16.1894977 C94.3712984,13.8835616 92.4920273,12 90.1799544,12 C87.8678815,12 86,13.8835616 86,16.1894977 C86,18.4954338 87.8792711,20.3789954 90.1799544,20.3789954 C91.1025057,20.3789954 92.0250569,20.0593607 92.7653759,19.4771689 L95.2824601,22 L96,21.2808219 L93.4715262,18.7808219 Z M90.1799544,19.3858447 C88.4373576,19.3858447 87.0136674,17.9589041 87.0136674,16.2123288 C87.0136674,14.4657534 88.4373576,13.0388128 90.1799544,13.0388128 C91.9225513,13.0388128 93.3462415,14.4657534 93.3462415,16.2123288 C93.3462415,17.9589041 91.9225513,19.3858447 90.1799544,19.3858447 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4a46e516.svg";
export { ForwardRef as ReactComponent };